import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { Message } from '../../models/chat.model';

@Component({
	selector: 'app-message-list',
	templateUrl: './message-list.component.html',
	styleUrls: ['./message-list.component.scss'],
})
export class MessageListComponent implements AfterViewChecked {
	@Input() messages: Message[] = [];
	@Input() isLoading = false;
	@Input() isSidecar = false;
	@Output() openArtifact = new EventEmitter<{ title: string; content: string }>();
	@Output() viewDocument = new EventEmitter<{ title: string; s3FileVersionGUID: string }>();
	@Output() requestFullscreen = new EventEmitter<{ title: string; s3FileVersionGUID: string }>();
	@ViewChild('scrollContainer') scrollContainer!: ElementRef;

	private shouldAutoScroll = true;
	private lastMessageCount = 0;

	trackByMessageId(_index: number, message: Message): string {
		return message.id;
	}

	ngAfterViewChecked(): void {
		const messageCountChanged = this.messages.length !== this.lastMessageCount;

		if (messageCountChanged) {
			const lastMsg = this.messages[this.messages.length - 1];
			const userSent = lastMsg?.role === 'user';
			this.lastMessageCount = this.messages.length;
			if (this.shouldAutoScroll || userSent) {
				this.shouldAutoScroll = true;
				this.scrollToBottom();
			}
		}
	}

	onScroll(): void {
		const el = this.scrollContainer?.nativeElement;
		if (!el) return;
		const threshold = 100;
		this.shouldAutoScroll = el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
	}

	scrollToBottom(): void {
		const el = this.scrollContainer?.nativeElement;
		if (el) {
			el.scrollTop = el.scrollHeight;
		}
	}

	get showScrollButton(): boolean {
		return !this.shouldAutoScroll;
	}

	shouldShowLabel(index: number): boolean {
		if (this.messages[index].role !== 'assistant') return false;
		if (index === 0) return true;
		return this.messages[index - 1].role !== 'assistant';
	}

	/** Get the user query that preceded this assistant message */
	getUserQuery(index: number): string {
		if (this.messages[index].role !== 'assistant') return '';
		// Walk backwards to find the preceding user message
		for (let i = index - 1; i >= 0; i--) {
			if (this.messages[i].role === 'user') return this.messages[i].content;
		}
		return '';
	}
}
